<template>
  <div>
    <!-- <div>
      <div v-for="(item,index) in menuItem" :key="index">
        <template v-if="!item.hidden">
          {{ item.meta.title }}{{ item.meta.icon }}</template>
      </div>
    </div> -->

    <Menu
      ref="contactMenu"
      theme="dark"
      :class="isCollapsed ? 'collapsed-menu' : ''"
      :active-name="activename"
      :open-names="openNames"
      style="padding-bottom: 88px"
    >
      <template v-for="item in menuItem">
        <template v-if="!item.hidden">
          <!-- 折叠菜单 -->
          <template v-if="hasOneChildren(item.children)">
            <!-- 判断是否隐藏 -->
            <Submenu v-if="isPermission(item.meta.permission)" :key="item.path" :name="item.path">
              <!--判断权限等级是否显示 -->
              <template slot="title">
                <Icon :type="item.meta.icon" />
                <span>{{ item.meta.title }}</span>
              </template>
              <!-- 判断子页面是否隐藏 -->
              <template v-for="zitem in item.children">
                <MenuItem v-if="!zitem.hidden" :key="zitem.path" :to="zitem.path" :name="zitem.path">
                  <Icon :type="zitem.meta.icon" />
                  <span>{{ zitem.meta.title }}</span>
                </MenuItem>
              </template>
            </Submenu>
          </template>
          <!-- 单项菜单 -->
          <template v-else>
            <MenuItem v-if="isPermission(item.meta.permission)" :key="item.path" :to="item.path" :name="item.path">
              <Icon :type="item.meta.icon" />
              <span>{{ item.meta.title }}</span>
            </MenuItem>
          </template>
        </template>
      </template>
    </Menu>
  </div>
</template>

<script>
export default {
  name: 'XMenu',
  props: {
    menuItem: {
      type: Array,
      required: true,
    },
    isCollapsed: {
      type: Boolean,
    },
  },
  computed: {
    // 菜单选中高亮
    activename() {
      const box = /\/index/;
      return this.$route.path.replace(box, '');
    },
    // 二级菜单展开
    openNames() {
      // 使用路由匹配记录获取真实父路由，不能直接截取 URL。
      // 例如 /proinfo/prolist 实际属于 /system 路由下的子页面。
      const parentRoute = this.$route.matched[0];
      return parentRoute ? [parentRoute.path] : [];
    },
  },
  methods: {
    /**
     * 判断children长度是否大于1
     */
    hasOneChildren(children = []) {
      if (children.length > 1) {
        return true;
      }
      return false;
    },
    /**
     * 判断路由是否有权限，如果有权限判断和存储权限对比
     */
    isPermission(permission) {
      // 没有设置过权限的路由全部显示
      if (typeof permission === 'undefined') {
        return true;
      } else {
        // 设备权限的 和本地存储的对比 等于就显示 ****以后对应接口可用大于等于****
        if (JSON.parse(localStorage.getItem('AC_USER_INFO')).type === permission) {
          return true;
        } else {
          return false; // 没有权限就不显示
        }
      }
    },
  },
};
</script>
<style lang="scss">
.ivu-layout-sider-trigger,
.ivu-menu-dark,
.ivu-menu,
.ivu-layout-sider {
  background: #051e34;
  font-weight: bold;
}
.ivu-menu-item {
  color: #5f788e !important;
}
.ivu-menu-item-active {
  color: #fff !important;
  background: #0062ff !important;
}
</style>
<style scoped>
.collapsed-menu i {
  transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
  font-size: 18px;
}
</style>
